(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.BentleyMobileReturn = api;
})(typeof window !== 'undefined' ? window : this, function() {
  var key = 'bentley.mobile.return.v1';
  var lifetime = 4 * 60 * 60 * 1000;
  function callback(value, host) {
    if (host !== 'orders.preprod2.bp.squadintouch.com' || typeof value !== 'string' || value.length > 600) return;
    try {
      var url = new URL(value);
      if (url.username || url.password || url.search || url.hash || value !== value.trim()) return;
      if (url.protocol === 'bentleyphoto-dev:' && !url.hostname && !url.port && (!url.pathname || url.pathname === '/'))
        return url.href;
      var ip = url.hostname.split('.').map(Number);
      var privateIp =
        /^\d+\.\d+\.\d+\.\d+$/.test(url.hostname) &&
        ip.every(function(n) {
          return n >= 0 && n <= 255;
        }) &&
        (ip[0] === 10 ||
          ip[0] === 127 ||
          (ip[0] === 192 && ip[1] === 168) ||
          (ip[0] === 172 && ip[1] >= 16 && ip[1] <= 31));
      if (
        url.protocol === 'exp:' &&
        privateIp &&
        /^\d{2,5}$/.test(url.port) &&
        Number(url.port) <= 65535 &&
        (url.pathname === '/' || url.pathname === '/--/' || !url.pathname)
      )
        return url.href;
    } catch (error) {
      /* Invalid callbacks never become browser navigation targets. */
    }
  }
  function save(storage, host, value, now) {
    var url = callback(value, host);
    if (!url) throw new Error('Invalid app return');
    storage.setItem(key, JSON.stringify({ url: url, expires: now + lifetime }));
  }
  function read(storage, host, now) {
    try {
      var entry = JSON.parse(storage.getItem(key));
      if (entry && typeof entry.expires === 'number' && entry.expires > now && entry.expires <= now + lifetime)
        return callback(entry.url, host);
    } catch (error) {
      /* Blocked storage and stale/malformed entries use manual return. */
    }
  }
  function clear(storage) {
    storage.removeItem(key);
  }
  function hosted(value) {
    if (typeof value !== 'string' || value.length > 1500 || value !== value.trim()) return;
    try {
      var url = new URL(value);
      var parts = decodeURIComponent(url.pathname).split('/');
      var token = /^[A-Za-z0-9_-]+={0,2}$/;
      if (
        url.protocol === 'https:' &&
        (url.hostname === 'secure.pay360.com' || url.hostname === 'secure.mite.pay360.com') &&
        !url.port &&
        !url.username &&
        !url.password &&
        !url.search &&
        !url.hash &&
        parts.length === 5 &&
        parts[1] === 'hosted' &&
        parts[3] === 'begin' &&
        parts[2].length <= 200 &&
        parts[4].length <= 200 &&
        token.test(parts[2]) &&
        token.test(parts[4])
      )
        return url.href;
    } catch (error) {
      /* Only existing hosted provider destinations are supported. */
    }
  }
  return { callback: callback, save: save, read: read, clear: clear, hosted: hosted };
});
